import { OnlyHelperTooltipProps, TradeStatus } from "@shared/types";
import { TRADE_STATUS_IN_CANCEL_HELPER_TOOLTIP } from "@shared/common/Tooltips/constants";

export const TRADES_DATA_ALLOCATED_AMOUNT_BTC_HEADER = "allocated_amount_btc";
export const TRADES_DATA_ALLOCATED_AMOUNT_USD_HEADER = "allocated_amount_usd";
export const TRADES_DATA_USD_AMOUNT_CHANGE_HEADER = "usd_amount_change";
export const TRADES_DATA_BTC_AMOUNT_CHANGE_HEADER = "btc_amount_change";
export const OpenTradeStatus = new Set([
  TradeStatus.BUYING_STAGE,
  TradeStatus.SELLING_STAGE,
  TradeStatus.IN_EDIT,
  TradeStatus.IN_CANCEL,
]);
export const ClosedTradeStatus = new Set([
  TradeStatus.FULFILLED,
  TradeStatus.CANCELLED,
  TradeStatus.STOPPED_OUT,
  TradeStatus.PARTIAL_FULFILLED,
  TradeStatus.LIQUIDATED,
  TradeStatus.POSITION_CLOSED,
  TradeStatus.SUBSCRIPTION_ENDED,
  TradeStatus.MARKET_IS_NOT_AVAILABLE,
  TradeStatus.CLIENT_DELETED,
  TradeStatus.INACTIVE,
  TradeStatus.PENDING,
  TradeStatus.EDITED,
]);

export const EDIT_TRADE_TAKE_PROFIT_REACHED_WARNING =
  "You can't add entry orders after a take-profit target was reached.";
export const EDIT_GRID_BOT_TRADE_WARNING =
  "You can't edit trades that were created by a grid bot. Please edit the bot instead.";
export const SHARE_GRID_BOT_TRADE_WARNING =
  "You can't share trades that were created by a grid bot.";
export const SHARE_INACTIVE_ACCOUNT_TRADE_WARNING =
  "You can't share trades that are connected to an inactive account.";
export const EDIT_INACTIVE_ACCOUNT_TRADE_WARNING =
  "You can't edit trades that are connected to an inactive account.";

export const BULK_CLOSE_TRADES_MUTATION_KEY = "bulkCloseTrades";

export const TITLE_TO_VALUE_TO_HELPER_TOOLTIP: Record<
  string,
  Record<string | number, OnlyHelperTooltipProps>
> = {
  ["Status"]: {
    ["Waiting for cancel verification"]: TRADE_STATUS_IN_CANCEL_HELPER_TOOLTIP,
  },
};

export const GET_TRADES_ARGS_KEY_TO_TRADE_DATA_KEY = {
  exchange: "exchange",
  account_id: "client_id",
  coin: "symbol",
  dca_bot_id: "bot_id",
  signal_id: "signal_id",
};

export const MOBILE_GET_OPEN_TRADES_ARGS = { add_price_graph_data: true };

export const CONFIRM_EDIT_AUTOMATED_SIGNAL_TRADE =
  "This trade was automatically created from a group signal. If you edit the trade, it will stop receiving future updates when the original signal is updated.";
